import './App.css';
import { useEffect, useState } from 'react'
import {
  Row,
  Col,
  Container,
  Image,
  Text,
  // @ts-ignore
} from 'atomize';
import { contractId } from './contractId'
import queryString from 'query-string';
import { useLocation } from "react-router-dom";

// @ts-ignore
const ethers = require('ethers')
const contractABI = require('./MoreOrLessVote.json').abi
function YourVote() {
  const location = useLocation()

  const svgHead = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" id="moreorless" width="1000" height="1000" viewBox="0 0 1000 1000">`
  const svgBottom = `</svg>`

  // @ts-ignore
  const [account, setAccount] = useState('')
  const [svg, setSVG] = useState(`${svgHead}${svgBottom}`)
  const [latestMint, setLatestMint ] = useState(0)
  const [latestName, setLatestName] = useState('')
  const [latestVote, setLatestVote] = useState('')
  const [showSampleVideo, setShowSampleVideo] = useState(true)
  const [alreadyVoted, ] = useState('')
  const [votesAtTime, setVotesAtTime] = useState('')
  const [decider, setDecider] = useState(false)
  const [influencer, setInfluencer] = useState(false)

  useEffect(() => {

    const wrapper = async () => {
      if (location.search) {
        let params = queryString.parse(location.search)
        console.log(params.address)
        if (params.address) {
          setAccount(params.address as string)
          let ethersProvider
          let moreOrLessContract
          let supply
          try {
            ethersProvider = new ethers.providers.EtherscanProvider("mainnet", "73T15M74Q2IWKJB6SQY8SN6NXGT1ZHTCR8")
            moreOrLessContract = new ethers.Contract(contractId, contractABI, ethersProvider);
            supply = await moreOrLessContract.totalSupply()
          } catch (e) {
            console.log(e)
            return;
          }
      
          console.log(`Supply: ${supply}`)
          setShowSampleVideo(false)

          const hasToken = await moreOrLessContract.balanceOf(params.address)
          let tokenNumber
          if (hasToken) {
            for (let i = 0; i < ethers.BigNumber.from(supply).toNumber(); i++) {
              const ownerOf = await moreOrLessContract.ownerOf(i)
              console.log(ownerOf)
              if (ownerOf.toLowerCase() == `${params.address}`.toLowerCase()) {
                tokenNumber = i
              }
            }
          }
          console.log(tokenNumber)

          if (tokenNumber || tokenNumber == 0) {
            const svg = await moreOrLessContract.tokenURI(ethers.BigNumber.from(tokenNumber).toNumber())
            console.log(svg)
            console.log(svg.substring(27,))
            const meta = JSON.parse(svg.substring(27,))
            setSVG(meta.image)
            setLatestName(meta.name)
            setLatestMint(ethers.BigNumber.from(tokenNumber).toNumber())
            setLatestVote(meta['attributes'].find((attribute: any) => attribute.trait_type === 'Token Vote')?.value)
            setVotesAtTime(meta['attributes'].find((attribute: any) => attribute.trait_type === 'Votes at Time')?.value)
            setDecider(meta['attributes'].find((attribute: any) => attribute.trait_type === 'Decider')?.value || 'False')
            setInfluencer(meta['attributes'].find((attribute: any) => attribute.trait_type === 'Influencer')?.value || 'False')
          }
        }
      }
    }

    wrapper()
  }, [latestMint, alreadyVoted, location.search])

  return (
    <Container className="App" fontFamily="code">
      <Row  height="100px" width="100px" p={{t: '5%'}}>
        <Col>
            <Text p={{t: '25%'}}>
              Vote Number: { latestMint }
              <br />
              Vote: { latestVote }
              <br />
              Voted by: { account }
              <br />
              Votes at Time: { votesAtTime }
              <br />
              Decider: { decider }
              <br />
              Influencer: { influencer }
            </Text>
        </Col>
        <Col height="100px" width="100px">
          { showSampleVideo ? (
            <video src={'/example_mints.mp4'} autoPlay muted loop width="300px" height="300px" />
          ) : (
            <Image src={`${svg}`} alt="Current state" width="300px" height="300px" style={{width: '400px', height: '400px'}} />
          )}
          <Text>{latestName}</Text>
          { !showSampleVideo && <Text>Voted "{latestVote}" by {account.substring(0,5)}...{account.substring(37,)}</Text>}
        </Col>
      </Row>
    </Container>
  );
}

export default YourVote;
